import { render, staticRenderFns } from "./shishi.vue?vue&type=template&id=0481baba&scoped=true&"
import script from "./shishi.vue?vue&type=script&lang=js&"
export * from "./shishi.vue?vue&type=script&lang=js&"
import style0 from "./shishi.vue?vue&type=style&index=0&id=0481baba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0481baba",
  null
  
)

export default component.exports